import theme from "../../../styles/theme"
import { ResponsiveBar } from "@nivo/bar"
import { useState } from 'react';
import { useEffect } from 'react';

const ChartStaticInoutItem = (param) => {

    const [chartData, setChartData] = useState([]);

    useEffect(()=>{

        if(param.row.chart){
            // console.log(param.row)
            const temp = {
                '정상반입': param.row.cnt_in_n,
                '미사용/반납': param.row.cnt_in_d,
                '고장/장애/파손': param.row.cnt_in_e+param.row.cnt_in_b,
                '분실/도난/기타': param.row.cnt_in_x+param.row.cnt_in_z,
            }
            // console.log(temp)
            setChartData(temp);
        }
    },[param.row.chart])

    return (
          <ResponsiveBar
              theme={{fontSize: '1rem'}}
              data={[chartData]}
              keys={[
                  '정상반입',
                  '미사용/반납',
                  '고장/장애/파손',
                  '분실/도난/기타',
              ]}
              margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
              padding={0.2}
              innerPadding={3}
              layout="horizontal"
              valueScale={{ type: 'symlog' }}
              indexScale={{ type: 'band', round: true }}
              colors={[theme.color.secondary.puppleB,theme.color.secondary.blueB,theme.color.secondary.greenB]}
              borderColor={{ theme: 'background' }}
              axisTop={null}
              axisRight={null}
              axisBottom={null}
              axisLeft={{
                  tickSize: 2,
                  tickPadding: 2,
                  tickRotation: 0,
                  legendOffset: -40
              }}
              enableGridY={false}
              labelSkipWidth={12}
              labelSkipHeight={12}
              labelTextColor={'#333333'}
              tooltip={()=>{return false}}
          />
    )
}

export default ChartStaticInoutItem;